Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _makeIcon = require('../../private/makeIcon');

var _makeIcon2 = _interopRequireDefault(_makeIcon);

var _iconCategories = require('../../utils/iconCategories');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var CloseSvg = function () {
  function CloseSvg(props) {
    return _react2['default'].createElement(
      'svg',
      props,
      _react2['default'].createElement('path', {
        d: 'm23.25 24c-.19 0-.38-.07-.53-.22l-10.72-10.72-10.72 10.72c-.29.29-.77.29-1.06 0s-.29-.77 0-1.06l10.72-10.72-10.72-10.72c-.29-.29-.29-.77 0-1.06s.77-.29 1.06 0l10.72 10.72 10.72-10.72c.29-.29.77-.29 1.06 0s .29.77 0 1.06l-10.72 10.72 10.72 10.72c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22',
        fillRule: 'evenodd'
      })
    );
  }

  return CloseSvg;
}();

CloseSvg.componentCategory = 'Core';
CloseSvg.displayName = 'CloseSvg';
CloseSvg.defaultProps = {
  viewBox: '0 0 24 24'
};


var IconClose = (0, _makeIcon2['default'])(CloseSvg, 'IconClose');
exports['default'] = IconClose;


if (process.env.NODE_ENV !== 'production') {
  IconClose.categories = [_iconCategories.MISCELLANEOUS];
}


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/exp/icons/IconClose.js
// module id = 421
// module chunks = 923280921217